import React, { useCallback, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@material-ui/core';

import AppButton from '@/components/app-button';
import { useSubscribeToNewsMutation, useUnsubscribeToNewsMutation } from '@/graphql';

const Unsubscribe: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const userId = searchParams.get('id')?.replaceAll('/', '');
  const userEmail = searchParams.get('email')?.replaceAll('/', '');

  const [unsubscribe, { loading: unLoading }] = useUnsubscribeToNewsMutation({ context: { errorHandling: 'notify' } });
  const [subscribe, { loading: subLoading }] = useSubscribeToNewsMutation({ context: { errorHandling: 'notify' } });

  useEffect(() => {
    const load = async () => {
      try {
        await unsubscribe({
          variables: {
            userId,
          },
        });
      } catch (error) {
        console.error('UNSUBSCRIBE_TO_NEWS', error);
      }
    };

    if (userId) load();
  }, [unsubscribe, userId]);

  const reSubscribe = useCallback(async () => {
    try {
      await subscribe({
        variables: {
          userId,
        },
      });

      navigate(`/subscribed-to-news?email=${userEmail}`);
    } catch (error) {
      console.error('SUBSCRIBE_TO_NEWS', error);
    }
  }, [navigate, subscribe, userId, userEmail]);

  return (
    <>
      <Box mt={3} mb={7}>
        <Typography variant="body2">{t('unsubscribe.sub-title')}</Typography>
      </Box>
      <AppButton
        fullWidth
        color="primary"
        variant="contained"
        loading={unLoading || subLoading}
        onClick={reSubscribe}
      >
        {t('unsubscribe.re-subscribe')}
      </AppButton>
    </>
  );
};

export default Unsubscribe;
